import { ADD_TO_CART } from '../queries/product';
import { useMutation } from '@apollo/client';

const useAddToCartMutation = (input: any, options: any) => {
    /**
     * Adding product to cart
     * Original and should be used is ADD_TO_CART
     */
    const mutation = useMutation(ADD_TO_CART, {
        variables: {
            input: input,
        },
        ...options,
        onError: (error) => {
            if (error) {
                // eslint-disable-next-line no-console
                console.error('=== ADD TO CART ERROR - DETAILED DEBUG INFO ===');

                // Log the basic error message
                // eslint-disable-next-line no-console
                console.error('Error Message:', error?.graphQLErrors?.[0]?.message ?? error.message);

                // Log all GraphQL errors with full details
                if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                    // eslint-disable-next-line no-console
                    console.error('GraphQL Errors:', JSON.stringify(error.graphQLErrors, null, 2));
                }

                // Log network errors
                if (error.networkError) {
                    // eslint-disable-next-line no-console
                    console.error('Network Error:', error.networkError);
                }

                // Log the input variables being sent
                // eslint-disable-next-line no-console
                console.error('Input Variables:', JSON.stringify(input, null, 2));

                // Log the complete error object for maximum debugging info
                // eslint-disable-next-line no-console
                console.error('Complete Error Object:', JSON.stringify(error, null, 2));

                // eslint-disable-next-line no-console
                console.error('=== END ERROR DEBUG INFO ===');
            }
        },
    });

    return mutation;
};

export default useAddToCartMutation;
